import React from 'react';

const NoData = () => (
  <div className="datatable-loading">
    <div className="packiot-loading" />
    <span className="datatable-loading-info">{'No data for this period.'}</span>
  </div>
);

export default NoData;
